// Translator notes: Finnish → HV front-end fixes from the Voikko-sorted unknown words (npm run tr:fi-unknowns,
// 2026-10-09; engine/src/rules/fi-adessive-state.ts). Each id is an engine note (`notes.add(text, id, args)`);
// `args` names its arguments in the order the strings take them. Collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  fiAdessiveState: {
    args: ['word', 'hv'],
    fi: (a: string[]) => `”Minulla on ${a[0]}” sanotaan valyriaksi yhdellä verbillä: ${a[1]}.`,
    en: (a: string[]) => `“Minulla on ${a[0]}” (I am hungry) is one verb in High Valyrian: ${a[1]}.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
